import React from "react";
import {
  Link,
  DetailedAlertMessages
} from "@sentara-health/optimahealth_web";
import { useTranslation, Trans } from "react-i18next";


const MaintenanceBanner: React.FC = () => {

  const { t } = useTranslation();

  return (
    <DetailedAlertMessages
      additionalInfo={
        <Trans
          i18nKey="common.maintenanceBannerDetails"
          values={{ phone: t("maintenance.maintenanceNo") }}
          components={{
            link1: (
              <Link
                to={`tel:+${t("maintenance.maintenanceNo")}`}
                className="banner-link"
                data-testid="paymentPhoneLink"
              />
            ),
            link2: (
              <Link
                to={t("common.memberResourcesURL")}
                target="_blank"
                className="text-decoration-underline medium-link"
                dataTestId="paymentOptionsLink"
              >
                {t("maintenance.memberResourcesPage")}
              </Link>
            ),
          }}
        />
      }
      message={t('common.maintenanceBanner')}
      variant="bannerwarning"
      collapsible
      defaultCollapsed="true"
      type="warning"
    >
    </DetailedAlertMessages>
  );
};

export default MaintenanceBanner;